// The shortcuts above a recording's detail sections: one per section with its count, kept in view
// while the rail scrolls. A shortcut opens its section (folded or not) and scrolls to it.
// Pure: the sections and the jump arrive as props.
import type React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'

export interface RailSectionLink<Id extends string> {
  id: Id
  label: string
  /** Omitted for a section that is one text (the summary). */
  count?: number
  icon: React.ReactNode
}

export function RailSectionNav<Id extends string>({
  sections,
  onJump,
}: {
  sections: readonly RailSectionLink<Id>[]
  onJump: (id: Id) => void
}) {
  const { t } = useTranslation()
  return (
    <nav
      aria-label={t('documents.detail.sections.nav')}
      className="sticky top-0 z-10 -mx-1 -mt-2 flex flex-wrap gap-1.5 border-b border-border bg-card px-1 py-2"
    >
      {sections.map(section => (
        <Button
          key={section.id}
          type="button"
          size="sm"
          variant="outline"
          className="h-7 gap-1.5 px-2 text-xs"
          onClick={() => onJump(section.id)}
        >
          {section.icon}
          {section.label}
          {section.count === undefined ? null : (
            <span className="font-mono tabular-nums text-muted-foreground">{section.count}</span>
          )}
        </Button>
      ))}
    </nav>
  )
}
